import { formatDistanceToNow } from "date-fns";

function TimeAgo({ date }) {
  const parsedDate = new Date(date);

  if (isNaN(parsedDate.getTime())) {
    return <span>n/a</span>; // fallback for invalid dates
  }

  const timeAgo = formatDistanceToNow(parsedDate, { addSuffix: true });

  return <span>{timeAgo}</span>;
}

export default TimeAgo;
